module.exports = __webpack_public_path__ + "img/PL00194.8b880f12.svg";